import { render, staticRenderFns } from "./YouTubeChannelDetail.vue?vue&type=template&id=c0bd6756&scoped=true"
import script from "./YouTubeChannelDetail.vue?vue&type=script&lang=js"
export * from "./YouTubeChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./YouTubeChannelDetail.vue?vue&type=style&index=0&id=c0bd6756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bd6756",
  null
  
)

export default component.exports